<template>
  <CHeader position="sticky" class="mb-4">
    <CContainer fluid class="flex justify-content-between" to="/">
      <CButton @click="setMenu" type="button">
        <CIcon icon="cil-menu"></CIcon>
      </CButton>
      <img :src="require('@/assets/bridgestone_logo.svg')" />
      <CButtonGroup role="group" aria-label="Basic example">
        <CButton color="primary" type="button" @click="setUpLocale('nl')" v-if="canSeeLanguageSwitcher">
          <img class="flag" :src="require('@/assets/images/flags/nl.png')" />
        </CButton>
        <CButton color="primary" type="button" @click="setUpLocale('en')" v-if="canSeeLanguageSwitcher">
          <img class="flag" :src="require('@/assets/images/flags/en.png')" />
        </CButton>
        <CButton color="primary" type="button" :title="$t('message.buttons.setMaintenance')"
          v-if="!isMaintenance && isAdmin" @click="createMaintenance()" :disabled="loading">
          {{ $t('message.buttons.setMaintenance') }}
        </CButton>
        <CButton color="danger" type="button" :title="$t('message.buttons.hideMaintenance')"
          v-else-if="isMaintenance && isAdmin" @click="openDisableMaintenanceModal()" :disabled="loading">
          {{ $t('message.buttons.hideMaintenance') }}
        </CButton>
        <CButton @click="logout" type="button" :title="$t('message.logout')" :disabled="loading">
          <CIcon icon="cil-account-logout"></CIcon>
        </CButton>
      </CButtonGroup>
    </CContainer>
    <CHeaderDivider />
    <CContainer fluid>
      <AppBreadcrumb />
    </CContainer>

    <CModal size="xl" :visible="showMaintenanceModal" @close="closeMaintance">
      <MaintananceInfo :mode="maintenanceModalMode" @close="closeMaintance" />
    </CModal>
  </CHeader>
</template>

<script setup>
import AppBreadcrumb from './AppBreadcrumb'
import MaintananceInfo from '@/components/MaintananceInfo'
import { UserService } from '@/services/user.service'
import store from '@/store'
import { ref, watch, computed } from 'vue'
import TokenService from '@/services/storage.service'
import { getTenantConfigValue } from '@/helpers/tenantModules'

const menuVisible = ref(true)
const showMaintenanceModal = ref(false)
const maintenanceModalMode = ref('enable')
const logout = async () => await UserService.logout(true)
let loading = computed(() => store.getters.getPending)

const roles = computed(() => store.getters.getAdminRole)
const isAdmin = computed(() => roles.value.find((item) => item.name == 'admin'))
const canSeeLanguageSwitcher = getTenantConfigValue('canSeeLanguageSwitcher', false)

const isMaintenance = computed(() => store.getters.getIsMaintenance)

const setMenu = () => {
  menuVisible.value = !menuVisible.value
  store.dispatch('setMenuVisible', menuVisible.value)
}

watch(
  () => store.getters.getMenuVisible,
  (newVal) => {
    menuVisible.value = newVal
  },
)

const createMaintenance = () => {
  maintenanceModalMode.value = 'enable'
  showMaintenanceModal.value = true
}

const openDisableMaintenanceModal = () => {
  maintenanceModalMode.value = 'disable'
  showMaintenanceModal.value = true
}

const closeMaintance = () => {
  showMaintenanceModal.value = false
}

const setUpLocale = (lang) => {
  TokenService.setLang(lang)
  window.location.reload()
}
</script>

<style scoped>
.flag {
  width: 100%;
  max-width: 20px;
}
</style>
